<template>
  <div class="container">
    <img src="../../assets/images/seckill/loading.gif" alt="" />
    <p>{{ $t('seckillLimit.moment') }}</p>
  </div>
</template>

<script>
export default {
  data () {
    return {
      timer: ''
    }
  },
  created () {
    this.timer = setTimeout(() => {
      console.log('object')
      this.$router.go(0)
    }, 10000)
  },
  destroyed () {
    if (this.timer) { // 如果定时器在运行则关闭
      clearInterval(this.timer)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  top: 40%;
  transform: translateY(-50%);
}
img {
  width: vw(375);
  height: auto;
  margin: 0 auto 0;
}
p {
  text-align: center;
  color: #969799;
  font-size: vw(14);
  vertical-align: middle;
  padding-top: vw(10);
}
</style>
